module.exports = __webpack_public_path__ + "static/media/mvu_logo.66bf9eb9.svg";